import React from 'react';
import { useDispatch } from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Icon from 'app/main/components/Icon';
import { navbarToggleMobile } from 'app/store/fuse/navbarSlice';

interface NavbarMobileToggleButtonProps {
	className?: string;
	children?: React.ReactNode;
}

function NavbarMobileToggleButton({ className, children = <Icon icon="menu" /> }: NavbarMobileToggleButtonProps) {
	const dispatch = useDispatch();

	return (
		<IconButton className={className} onClick={ev => dispatch(navbarToggleMobile())} color="inherit" disableRipple>
			{children}
		</IconButton>
	);
}

export default NavbarMobileToggleButton;
